export function SAVE_FILTERS(state, [favorite, progress, search, selected_areas, selected_groups, selected_tags]){
    state.favorite = favorite
    state.progress = progress
    state.search = search
    state.selected_areas = selected_areas
    state.selected_groups = selected_groups
    state.selected_tags = selected_tags
}

export function SAVE_PLAYLIST(state, [playlist]){
    state.playlist = playlist
}

export function SAVE_ORIGIN(state, [origin]){
    state.origin = origin
}

export function SAVE_TRAIL_ID(state, [trail_id]){
    state.trail_id = trail_id
}

export function SAVE_FILTERS_SEARCH(state, [search]){
    state.search = search
}

export function SAVE_PROGRESS(state, progress){
    state.progress = progress
}

export function SAVE_FILTER_AREA(state, selected_areas){
    state.selected_areas = selected_areas
}

export function SAVE_LOADING(state, loading){
    state.loading = loading
}

export function SAVE_PODCAST_ID(state, podcast_id){
    state.podcast_id = podcast_id
}